// import React, { createContext, useState, useContext, useEffect } from 'react';
// import subscriptionEnforcement from '../services/subscriptionEnforcement';

// const SubscriptionContext = createContext();

// export function useSubscription() {
//   return useContext(SubscriptionContext);
// }

// export function SubscriptionProvider({ children }) {
//   const [accessStatus, setAccessStatus] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     checkAccess();
//     // Check access every 5 minutes
//     const interval = setInterval(checkAccess, 5 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, []);

//   async function checkAccess() {
//     console.log('Checking subscription access...'); // DEBUG
//     const status = await subscriptionEnforcement.checkAccess();
//     console.log('Access status:', status); // DEBUG
//     setAccessStatus(status);
//     setLoading(false);

//     // REMOVED auto-redirect - let user see what's happening
//     // if (!status.allowed && status.requiresSync) {
//     //   window.location.href = '/lockout';
//     // }
//   }

//   async function canPerformAction(action) {
//     return await subscriptionEnforcement.canPerformAction(action);
//   }

//   const value = {
//     accessStatus,
//     checkAccess,
//     canPerformAction,
//     isReadOnly: accessStatus?.access === 'readonly',
//     isLocked: !accessStatus?.allowed
//   };

//   if (loading) {
//     return null; // Don't block rendering while checking subscription
//   }

//   return (
//     <SubscriptionContext.Provider value={value}>
//       {children}
//     </SubscriptionContext.Provider>
//   );
// }


// src/context/SubscriptionContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import subscriptionEnforcement from '../services/subscriptionEnforcement';

const SubscriptionContext = createContext();

export function useSubscription() {
  return useContext(SubscriptionContext);
}

export function SubscriptionProvider({ children }) {
  const [accessStatus, setAccessStatus] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkAccess();
    
    // Check access every 5 minutes
    const interval = setInterval(checkAccess, 5 * 60 * 1000);
    
    // Listen for sync completion
    const handleSyncComplete = () => {
      // console.log('🔄 Sync completed - rechecking subscription');
      checkAccess();
    };
    
    // Listen for subscription updates
    const handleSubscriptionUpdate = () => {
      // console.log('🔄 Subscription updated - rechecking');
      checkAccess();
    };
    
    window.addEventListener('sync-completed', handleSyncComplete);
    window.addEventListener('subscription-updated', handleSubscriptionUpdate);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('sync-completed', handleSyncComplete);
      window.removeEventListener('subscription-updated', handleSubscriptionUpdate);
    };
  }, []);

  // ⭐ Auto-redirect when subscription becomes invalid
  useEffect(() => {
    if (loading || !accessStatus) return;

    const allowedPaths = ['/subscribe', '/login', '/register', '/', '/pricing'];
    const currentPath = location.pathname;
    const isAllowedPath = allowedPaths.some(path => currentPath.startsWith(path));

    // ⭐ Redirect if no access and not already on allowed page
    if (!accessStatus.allowed && !isAllowedPath) {
      // console.warn('⚠️ No valid subscription - redirecting to /subscribe');
      navigate('/subscribe', {
        replace: true,
        state: { from: currentPath, reason: accessStatus.reason }
      });
    }
    
    // ⭐ Also redirect if daysRemaining === 0 (expired today)
    else if (accessStatus.allowed && accessStatus.daysRemaining === 0 && !isAllowedPath) {
      // console.warn('⚠️ Subscription expires today (0 days) - redirecting to /subscribe');
      navigate('/subscribe', {
        replace: true,
        state: { from: currentPath, reason: 'expiring_today' }
      });
    }
  }, [loading, accessStatus, location.pathname, navigate]);

  async function checkAccess() {
    // console.log('📊 Checking subscription access...');
    try {
      const accessStatus = await subscriptionEnforcement.checkAccess();
      // console.log('✅ Access status:', accessStatus);
      
      setAccessStatus(accessStatus);
      
      if (accessStatus.subscription) {
        setSubscriptionData(accessStatus.subscription);
      }
    } catch (error) {
      // console.error('❌ Error checking access:', error);
      setAccessStatus({
        allowed: false,
        access: 'locked',
        message: 'Unable to verify subscription. Please check your internet connection.',
        requiresSync: true
      });
    } finally {
      setLoading(false);
    }
  }

  async function canPerformAction(action) {
    return await subscriptionEnforcement.canPerformAction(action);
  }

  const value = {
    accessStatus,
    subscriptionData,
    checkAccess,
    canPerformAction,
    isReadOnly: accessStatus?.access === 'readonly',
    isLocked: !accessStatus?.allowed,
    loading
  };

  if (loading) {
    return null;
  }

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}

// import React, { createContext, useState, useContext, useEffect } from 'react';
// import subscriptionEnforcement from '../services/subscriptionEnforcement';

// const SubscriptionContext = createContext();

// export function useSubscription() {
//   return useContext(SubscriptionContext);
// }

// export function SubscriptionProvider({ children }) {
//   const [accessStatus, setAccessStatus] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     checkAccess();
    
//     // Check access every 5 minutes
//     const interval = setInterval(checkAccess, 5 * 60 * 1000);
    
//     // ⭐ Listen for sync completion to re-check access
//     const handleSyncComplete = () => {
//       console.log('🔄 Sync completed - rechecking subscription access');
//       checkAccess();
//     };
    
//     window.addEventListener('sync-completed', handleSyncComplete);
    
//     return () => {
//       clearInterval(interval);
//       window.removeEventListener('sync-completed', handleSyncComplete);
//     };
//   }, []);

//   async function checkAccess() {
//     console.log('Checking subscription access...');
//     const status = await subscriptionEnforcement.checkAccess();
//     console.log('Access status:', status);
//     setAccessStatus(status);
//     setLoading(false);
//   }

//   async function canPerformAction(action) {
//     return await subscriptionEnforcement.canPerformAction(action);
//   }

//   const value = {
//     accessStatus,
//     checkAccess,
//     canPerformAction,
//     isReadOnly: accessStatus?.access === 'readonly',
//     isLocked: !accessStatus?.allowed
//   };

//   if (loading) {
//     return null; // Don't block rendering while checking subscription
//   }

//   return (
//     <SubscriptionContext.Provider value={value}>
//       {children}
//     </SubscriptionContext.Provider>
//   );
// }
